import React from 'react';
import {useTranslation} from 'react-i18next';
import FabNavigate from '../../../../assets/icons/FabNavigate';
import Globe from '../../../../assets/icons/Globe';
import LinkSheet, {SheetLink} from '../LinkSheet/LinkSheet';
import {TShow} from '../../../../hooks/useShow';
import {TEticketEvent} from '../../../../redux/eTicket/eTicket.type';
import {WAZE_NAV_URL, GOOGLE_MAPS_NAV_URL} from '../../../../config/config';

interface NavigationSheetProps {
    show: TShow;
    event?: TEticketEvent;
}

function NavigationSheet({show, event}: NavigationSheetProps): React.ReactElement | null {
    const {t} = useTranslation('eTicket');
    const destination = event?.address || event?.location;
    if(!destination) return null;

    const query = encodeURIComponent(destination);
    const links: SheetLink[] = [
        {key: 'waze', label: t('navWaze'), href: WAZE_NAV_URL(query), icon: <FabNavigate size={22} />, external: true},
        {key: 'googleMaps', label: t('navGoogleMaps'), href: GOOGLE_MAPS_NAV_URL(query), icon: <Globe width={22} height={22} />, external: true},
    ];

    return <LinkSheet show={show} title={t('navigate')} links={links} data-cy="ticket-fab-nav-sheet" />;
}

export default NavigationSheet;
